import * as notesModule from '@/store/notes/notesModule'

export const state = Object.assign({}, notesModule.defaults())

export default {
  namespaced: true,
  state,
  mutations: notesModule.mutations,
  actions: notesModule.actions,
  getters: notesModule.getters
}



// WEBPACK FOOTER //
// ./src/store/administration/clients/clientNotesModule.js